import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-value-loading',
    template: `
        @if (isLoading) {
            <span class="inline-flex items-center text-slate-500">
                <app-loading-ring class="me-2"></app-loading-ring>
                <span>{{ 'translate_loading' | translate }}</span>
            </span>
        } @else {
            {{ value }}
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ValueLoadingComponent {
    @Input() public isLoading = false;
    @Input() public value: any;
}
